import type React from 'react';

import type { IconProps } from 'types/icon';

const Phone: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M24.6875 20.6201C24.6873 19.7885 24.1388 19.0567 23.341 18.822L21.239 18.2031C20.5932 18.0132 19.8948 18.1985 19.4287 18.6841C18.5146 19.6362 17.0276 19.9422 15.8484 19.1797C13.8373 17.8792 12.1208 16.1627 10.8203 14.1516C10.0577 12.9724 10.3638 11.4853 11.3159 10.5713C11.8015 10.1051 11.9868 9.40675 11.7968 8.76099L11.1779 6.65894C10.9433 5.86112 10.2114 5.31271 9.37985 5.3125H7.15207C6.10458 5.31268 5.32368 6.14188 5.42355 7.08008C5.71478 9.81542 6.57575 12.4803 7.95895 14.8645C9.68332 17.8366 12.1633 20.3167 15.1355 22.041C17.5293 23.4298 20.1585 24.2524 22.8857 24.5544C23.8411 24.6602 24.6875 23.8696 24.6875 22.8125V20.6201ZM25.9375 22.8125C25.9375 24.5168 24.5381 25.995 22.749 25.7971C19.8611 25.4773 17.0626 24.6046 14.508 23.1226C11.3477 21.289 8.71099 18.6523 6.87741 15.4919C5.40465 12.9534 4.49035 10.1189 4.18088 7.21191C3.99174 5.43378 5.46793 4.06268 7.15207 4.0625H9.37985C10.7659 4.06271 11.9868 4.97636 12.3779 6.30615L12.9956 8.4082C13.3171 9.50145 13.0033 10.6829 12.1814 11.4722C11.5989 12.0313 11.4775 12.8658 11.8701 13.4729C13.0746 15.3354 14.6645 16.9254 16.5271 18.1299C17.1342 18.5225 17.9686 18.4011 18.5278 17.8186C19.3171 16.9967 20.4985 16.6829 21.5918 17.0044L23.6938 17.6221C25.0236 18.0132 25.9373 19.234 25.9375 20.6201V22.8125Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Phone;
